export default __webpack_public_path__ + "static/7-alternative-japanese-destinations-monkey-37b5169d26ef1e7a3dc061eccd1aef62.jpg";